function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m62.052 25.63a2.6688 2.6688 0 0 0-3.774 0l-29.07 29.194a13.345 13.345 0 0 1-18.875-18.871l28.155-28.27a8.0067 8.0067 0 1 1 11.325 11.322l-28.155 28.269a2.7277 2.7277 0 0 1-3.774 0 2.6688 2.6688 0 0 1 0-3.774l25.068-25.181a2.6693 2.6693 0 1 0-3.7755-3.7744l-25.066 25.182a8.0067 8.0067 0 0 0 0 11.324 8.2015 8.2015 0 0 0 11.324 0l28.152-28.272a13.344 13.344 0 1 0-18.873-18.87l-28.154 28.27a18.683 18.683 0 0 0 26.423 26.422l29.07-29.187a2.6688 2.6688 0 0 0 0-3.7846z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.35301
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.16a70e0e.svg";
export { ForwardRef as ReactComponent };